import { ContentCopy, MoveUp } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import React from 'react';

import { ModeDnd } from '@/features/viewSettings';
import { MuiColors } from '@/types/colors';

const modeIcons: Record<ModeDnd, React.ReactNode> = {
  [ModeDnd.Duplication]: <ContentCopy sx={{ width: '16px', height: '16px' }} />,
  [ModeDnd.Moving]: <MoveUp sx={{ width: '18px', height: '18px' }} />,
};

const modeLabels: Record<ModeDnd, string> = {
  [ModeDnd.Duplication]: 'Дублирование задач',
  [ModeDnd.Moving]: 'Перенос задач',
};

interface ModeSwitcherProps {
  value: ModeDnd;
  onChange: (mode: ModeDnd) => void;
}

export const ModeSwitcher: React.FC<ModeSwitcherProps> = ({ value, onChange }) => {
  const modeDnd = Object.values(ModeDnd);

  return (
    <div style={{ display: 'flex', borderRadius: 6, overflow: 'hidden' }}>
      {modeDnd.map((mode, index) => {
        const isActive = mode === value;
        const isFirst = index === 0;
        const isLast = index === modeDnd.length - 1;

        return (
          <Tooltip title={modeLabels[mode]} key={mode} arrow>
            <IconButton
              onClick={() => onChange(mode)}
              size="small"
              sx={{
                minWidth: 40,
                height: 32,
                padding: '4px',
                fontSize: '18px',
                backgroundColor: isActive ? MuiColors.accentColor : MuiColors.lightSecondaryColor,
                color: isActive ? MuiColors.additionalColor : MuiColors.darkSecondaryColor,
                borderRadius: 0,
                borderTopLeftRadius: isFirst ? '6px' : 0,
                borderBottomLeftRadius: isFirst ? '6px' : 0,
                borderTopRightRadius: isLast ? '6px' : 0,
                borderBottomRightRadius: isLast ? '6px' : 0,
                '&:hover': {
                  backgroundColor: isActive
                    ? MuiColors.accentHoverColor
                    : MuiColors.secondaryHoverColor,
                },
              }}
            >
              {modeIcons[mode]}
            </IconButton>
          </Tooltip>
        );
      })}
    </div>
  );
};
